/*------------------------------------*\
    MODULES
\*------------------------------------*/

/*------------------------------------*\
    STOP VIDEOS
\*------------------------------------*/
class StopVideos {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var iframe = self.elem.querySelector('iframe');
        var btn = self.elem.querySelector('button');

        btn.onclick = function() {
            if (iframe) {
                var iframeSrc = iframe.src;
                iframe.src = iframeSrc;
            }
        };
    }
}

export default StopVideos;
